module.exports = __webpack_public_path__ + "media/images/favicon-7631b395bef4b200f1a2941f31cde77a.png";